'use client'
import Section from 'components/Section'
import { Typography } from 'components/Contentful'
import { Button } from 'components/Button'
import { useMemoizedContentGetter } from 'utils/contentful'

const AchieveProIcon = () => (
  <svg width="81" height="25" viewBox="0 0 81 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4335 1.43118L7.15576 19.6594L9.94973 20.621L13.0644 11.5784C13.695 9.74703 15.4967 3.9453 15.4967 3.9453C15.4967 3.9453 17.2986 9.74703 17.9292 11.5784L20.7578 19.7914H23.8833L17.5599 1.43118C17.314 0.717195 16.541 0 15.4967 0C14.4525 0 13.6795 0.717195 13.4335 1.43118Z"
      fill="white"
    />
    <path
      d="M22.7091 6.72199C21.9754 6.36412 21.6706 5.47922 22.0286 4.7454C22.2846 4.22026 22.8107 3.91504 23.3582 3.91504C23.5756 3.91504 23.7964 3.96316 24.0051 4.06495L31.3147 7.34337L27.573 14.4269C27.2151 15.1606 26.3302 15.4654 25.5965 15.1075C24.8627 14.7497 24.5581 13.8648 24.9159 13.131C25.1328 12.6863 25.9082 11.5564 26.6449 10.5162L8.98569 16.5971L8.02686 13.8004L25.6861 7.71947C24.4637 7.353 23.1545 6.93928 22.7091 6.72199Z"
      fill="white"
    />
    <path
      d="M0 20.0749C0 17.9206 1.39006 16.0854 3.32173 15.4201L8.02711 13.7998L8.98594 16.5965L4.28407 18.2142C3.51204 18.4801 2.95613 19.2137 2.95613 20.0749C2.95613 21.1604 3.83928 22.0436 4.92485 22.0436C5.78598 22.0436 6.52519 21.4901 6.79119 20.7177L7.20316 19.5219L9.99713 20.4835L9.58531 21.6799C8.92032 23.6111 7.0792 24.9998 4.92485 24.9998C2.20919 24.9998 0 22.7905 0 20.0749Z"
      fill="white"
    />
    <path
      d="M43.3129 3.85584V10.4169H41.4148V9.5409C40.9628 10.2037 40.154 10.5769 39.2895 10.5769C37.5235 10.5769 36.1816 9.08897 36.1816 7.13755C36.1816 5.18614 37.5235 3.69824 39.2895 3.69824C40.1517 3.69824 40.9628 4.02966 41.4148 4.70871V3.85816H43.3129V3.85584ZM39.7925 8.83635C40.7357 8.83635 41.4797 8.0785 41.4797 7.13755C41.4797 6.19661 40.7357 5.43875 39.7925 5.43875C38.8492 5.43875 38.1052 6.19661 38.1052 7.13755C38.1052 8.0785 38.8492 8.83635 39.7925 8.83635Z"
      fill="white"
    />
    <path
      d="M47.6419 3.68298C48.212 3.68298 48.81 3.81508 49.2897 4.09551V5.91482C48.8378 5.595 48.3743 5.4374 47.869 5.4374C46.8585 5.4374 46.0891 6.14195 46.0891 7.1362C46.0891 8.13045 46.847 8.83499 47.869 8.83499C48.3858 8.83499 48.8911 8.62178 49.3036 8.32976V10.163C48.7729 10.455 48.1888 10.5871 47.6164 10.5871C45.5978 10.5871 44.1377 9.1919 44.1377 7.13388C44.1377 5.07586 45.5862 3.68066 47.6442 3.68066L47.6419 3.68298Z"
      fill="white"
    />
    <path
      d="M52.0917 10.4131H50.1519V1.11719H52.0917V4.6886C52.4903 4.05126 53.1531 3.68045 54.0315 3.68045C55.5333 3.68045 56.4488 4.70251 56.4488 6.3619V10.4131H54.5089V6.79993C54.5089 5.94937 54.0848 5.45804 53.3409 5.45804C52.5969 5.45804 52.0917 6.02817 52.0917 6.93203V10.4107V10.4131Z"
      fill="white"
    />
    <path
      d="M58.5579 3.08253C57.9344 3.08253 57.4292 2.56571 57.4292 1.95386C57.4292 1.34202 57.9344 0.825195 58.5579 0.825195C59.1813 0.825195 59.6865 1.34202 59.6865 1.95386C59.6865 2.56571 59.1813 3.08253 58.5579 3.08253ZM57.5891 10.4131V3.85197H59.5289V10.4131H57.5891Z"
      fill="white"
    />
    <path
      d="M66.8592 8.84658C66.3146 9.92194 65.2531 10.5871 63.8186 10.5871C61.7744 10.5871 60.3398 9.16641 60.3398 7.13388C60.3398 5.10135 61.7999 3.68066 63.7398 3.68066C65.6796 3.68066 67.0864 5.12916 67.0864 7.18718C67.0864 7.41199 67.0725 7.58581 67.0609 7.66461H62.2403C62.3075 8.43405 63.0097 8.99259 63.8209 8.99259C64.537 8.99259 64.924 8.68667 65.2276 8.19534L66.8616 8.84658H66.8592ZM65.1859 6.40384C65.1071 5.69929 64.5092 5.19637 63.7259 5.19637C62.9425 5.19637 62.3307 5.7804 62.2519 6.40384H65.1859Z"
      fill="white"
    />
    <path
      d="M66.9658 3.85449H69.0099L70.5511 7.99835L72.0923 3.85449H74.0855L71.4156 10.4156H69.6357L66.9658 3.85449Z"
      fill="white"
    />
    <path
      d="M80.4588 8.84658C79.9142 9.92194 78.8528 10.5871 77.4182 10.5871C75.374 10.5871 73.9395 9.16641 73.9395 7.13388C73.9395 5.10135 75.3995 3.68066 77.3394 3.68066C79.2792 3.68066 80.686 5.12916 80.686 7.18718C80.686 7.41199 80.6721 7.58581 80.6605 7.66461H75.8399C75.9071 8.43405 76.6093 8.99259 77.4205 8.99259C78.1366 8.99259 78.5237 8.68667 78.8273 8.19534L80.4612 8.84658H80.4588ZM78.7855 6.40384C78.7067 5.69929 78.1088 5.19637 77.3255 5.19637C76.5421 5.19637 75.9303 5.7804 75.8515 6.40384H78.7855Z"
      fill="white"
    />
    <path
      d="M36.5571 24.1749V14.8396H38.4854V15.718C38.9512 15.0389 39.7485 14.6797 40.6129 14.6797C42.3812 14.6797 43.7255 16.1699 43.7255 18.1236C43.7255 20.0774 42.3836 21.5676 40.6129 21.5676C39.7485 21.5676 38.9512 21.2478 38.4854 20.5571V24.1749H36.5571ZM40.1077 16.4225C39.1644 16.4225 38.4182 17.1804 38.4182 18.1236C38.4182 19.0669 39.1621 19.8247 40.1077 19.8247C41.0533 19.8247 41.7972 19.0669 41.7972 18.1236C41.7972 17.1804 41.0533 16.4225 40.1077 16.4225Z"
      fill="white"
    />
    <path
      d="M48.6712 16.7278C48.5646 16.6745 48.3792 16.649 48.1799 16.649C47.1022 16.649 46.4649 17.4463 46.4649 18.7372V21.4094H44.5366V14.8413H46.451V15.919C46.7963 15.1611 47.4892 14.6953 48.3398 14.6953C48.4858 14.6953 48.6318 14.7231 48.6712 14.7347V16.7302V16.7278Z"
      fill="white"
    />
    <path
      d="M52.3286 14.668C54.3635 14.668 55.8931 16.1698 55.8931 18.1258C55.8931 20.0819 54.3635 21.5837 52.3286 21.5837C50.2938 21.5837 48.7642 20.0819 48.7642 18.1258C48.7642 16.1698 50.2938 14.668 52.3286 14.668ZM52.3286 19.813C53.2325 19.813 53.9764 19.0691 53.9764 18.1235C53.9764 17.1779 53.2325 16.434 52.3286 16.434C51.4248 16.434 50.6808 17.1779 50.6808 18.1235C50.6808 19.0691 51.4248 19.813 52.3286 19.813Z"
      fill="white"
    />
    <path
      d="M56.4951 20.6533H57.5274V20.9314H57.1645V22.0439H56.8628V20.9314H56.4951V20.6533Z"
      fill="white"
    />
    <path
      d="M59.2996 20.6533V22.0392H59.0121V21.1436L58.602 22.0392H58.4087L58.0034 21.1483V22.0392H57.7158V20.6533H58.0788L58.5172 21.6196L58.9555 20.6533H59.3091H59.2996Z"
      fill="white"
    />
  </svg>
)

function ComparisonTable({ content }) {
  const sectionVariationObject = {
    ...content?.fields?.experiment,
    variant: content?.fields?.experimentVariation,
  }

  const memoizedContent = useMemoizedContentGetter(content, ['title', 'subtitle', 'config'])

  const { title, subtitle, config } = memoizedContent

  const comparisonData = config?.jsonContent?.comparisonData || []

  const achieveProLabel = config?.jsonContent?.achieveProLabel || 'Achieve Pro HELOC'
  const othersLabel = config?.jsonContent?.othersLabel || 'The others'
  const ctaText = config?.jsonContent?.ctaText || 'Partner with us'
  const ctaLink = config?.jsonContent?.ctaLink || '/achieve-pro/contact-us'

  const handleCTAClick = () => {
    if (ctaLink) {
      window.location.href = ctaLink
    }
  }

  return (
    <Section
      id="comparison-table"
      disableGutters
      className="py-[48px] breakpointMd:py-[80px] breakpointLg:px-[32px]"
    >
      {/* Desktop: grey inner container */}
      <div className="breakpointLg:bg-[#f8f9fc] breakpointLg:rounded-[24px] breakpointLg:py-[64px] breakpointLg:max-w-[1216px] breakpointLg:mx-auto">
        <div className="max-w-[1050px] mx-auto pl-[20px] pr-0 breakpointMd:pl-[32px] breakpointLg:px-[64px]">
          {/* Header */}
          <div className="text-center mb-[32px] breakpointLg:mb-12">
            <Typography
              variant="headingXl"
              content={title?.textContent || 'Achieve Pro vs. the others'}
              className="text-[#1D252F] text-[36px] md:text-[44px] font-bold leading-tight mb-4 text-left breakpointMd:text-center"
            />
            <Typography
              variant="bodySm"
              content={
                subtitle?.textContent || 'How our simpler, smarter HELOC stacks up against the rest'
              }
              className="text-[#1D252F] text-[16px] leading-relaxed text-left breakpointMd:text-center"
            />
          </div>

          {/* Comparison Table */}
          <div className="mb-8 overflow-x-auto pb-[16px]">
            <div className="w-[900px]">
              {/* Table Header */}
              <div className="grid grid-cols-[minmax(0,176px)_auto_1fr] breakpointMd:grid-cols-[1fr_auto_1fr] gap-0 mb-0">
                <div className=""></div>
                <div className="bg-[#2C47F6] rounded-t-[20px] px-8 py-5 pt-10 flex flex-col gap-2 w-[360px]">
                  <AchieveProIcon />
                  <Typography
                    variant="labelLg"
                    content={achieveProLabel}
                    className="text-white font-semibold text-[16px] breakpointMd:text-[18px] text-left"
                  />
                </div>
                <div className="px-8 py-5 flex items-end">
                  <Typography
                    variant="labelLg"
                    content={othersLabel}
                    className="text-[#1D252F] font-semibold text-[16px] breakpointMd:text-[18px] text-left"
                  />
                </div>
              </div>

              {/* Table Rows */}
              {comparisonData.map((row, index) => (
                <div
                  key={index}
                  className="grid grid-cols-[minmax(0,176px)_auto_1fr] breakpointMd:grid-cols-[1fr_auto_1fr] gap-0 min-h-[80px]"
                  style={{
                    borderTop: index === 0 ? '1px solid #000' : 'none',
                    borderBottom: index !== comparisonData.length - 1 ? '1px solid #000' : 'none',
                  }}
                >
                  {/* Label Column */}
                  <div className="pr-6 py-5 flex items-center justify-start h-full">
                    <Typography
                      variant="labelSm"
                      content={row.label}
                      className="text-[#1D252F] font-semibold text-[16px] breakpointMd:text-[18px] text-left!"
                    />
                  </div>

                  {/* Achieve Pro Column */}
                  <div
                    className={`bg-[#2C47F6] px-8 py-5 flex items-center w-[360px] h-full ${
                      index === comparisonData.length - 1 ? 'rounded-b-[20px]' : ''
                    }`}
                  >
                    <Typography
                      variant="bodySm"
                      content={row.achievePro}
                      className="text-white text-[16px] breakpointMd:text-[18px] leading-relaxed text-left"
                    />
                  </div>

                  {/* Others Column */}
                  <div className="px-8 py-5 flex items-center h-full">
                    <Typography
                      variant="bodySm"
                      content={row.others}
                      className="text-[#1D252F] text-[16px] breakpointMd:text-[18px] leading-relaxed text-left"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Button */}
          <div className="flex justify-center pr-[20px] breakpointMd:pr-0">
            <Button
              onClick={handleCTAClick}
              variant="contained"
              color="content-primary"
              className="w-full md:w-auto px-12 py-4 text-base font-semibold normal-case rounded-md bg-[#1D252F] hover:bg-[#2d3748] md:min-w-[240px]"
              track={{
                sectionVariationObject,
              }}
            >
              <Typography fontWeight="bold" content={ctaText} className="text-white" />
            </Button>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default ComparisonTable
